import {EventWizardFull} from './EventWizardFull';
export default EventWizardFull;